exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports
exports.locals = {
	"menuText": "#BFCBD9",
	"menuActiveText": "#409EFF",
	"subMenuActiveText": "#F4F4F5",
	"menuBg": "#fff",
	"menuHover": "#263445",
	"subMenuBg": "#1F2D3D",
	"subMenuHover": "#001528",
	"sideBarWidth": "200px"
};